import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { patchImageSlider } from 'redux/image-sliders/actions';

import CommonLinkCheckbox from 'components/common/link-elements/CommonLinkCheckbox';

function InstagramSliderIsPublished(props) {
  const { item, patchImageSlider } = props;

  const [initialIsVerified, setInitialIsVerified] = useState(item.instagram_is_verified);

  useEffect(() => {
    if (item.instagram_is_verified && item.instagram_is_verified !== initialIsVerified) {
      const form = new FormData();
      form.append('is_published', true);
      patchImageSlider(item.id, form);
      setInitialIsVerified(true);
    }
  }, [item.instagram_is_verified]);

  return (
    <div className="instagram-slider-is-published__component">
      <CommonLinkCheckbox
        key={`instagram-slider-is-published-checkbox-key-${item.id}`}
        linkId={item.id}
        initialValue={item.is_published}
        parameter="is_published"
        patchFunction={patchImageSlider}
        disabled={!item.instagram_is_verified}
      />
    </div>
  );
}

InstagramSliderIsPublished.propTypes = {
  patchImageSlider: PropTypes.func.isRequired,
  item: PropTypes.object.isRequired,
};

export default connect(
  null,
  {
    patchImageSlider,
  },
)(InstagramSliderIsPublished);
